module.exports = __webpack_public_path__ + "img/ggtg.3b51b9e3.png";